// extracted by css-extract-rspack-plugin
export default {"accordionItem":"FormPolicies-module__accordionItem","sectionClassname":"FormPolicies-module__sectionClassname","dividerClassname":"FormPolicies-module__dividerClassname"};